/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AppState } from '@app/core/types';
import { Action, INIT, UPDATE } from '@ngrx/store';
import merge from 'lodash-es/merge';

// ngrx-store-localstorage uses deepmerge package since 7.0.0 instead of lodash/merge.
// Merging of Map and Set between these two is different, the custom mergeReducer restores
// the 7.0.0 behavior.
// https://github.com/TehShrike/deepmerge/issues/204
export const mergeReducer = <T extends AppState>(state: T, rehydratedState: T, action: Action): T => {
  return (action.type === INIT || action.type === UPDATE) && rehydratedState
    ? merge({}, state, rehydratedState)
    : state;
};
